import React from 'react';
// import PageFooter from 'glic-ui-components/dist/js/PageFooter';
// import Text from 'glic-ui-components/dist/js/Text';
// import TextLink from 'glic-ui-components/dist/js/TextLink';
import { TextLink, PageFooter, Text, Button } from 'glic-ui-components';
import { Link } from 'react-router-dom';
const FooterMDG = () => {

    const gotoLink = (evt) => {
        evt.preventDefault();
        window.open(evt.target.id,
            "_blank", "width=900, height=600");
    }
    const currentYear = new Date().getFullYear();
    const openOneTrust = (e) => {
        e.preventDefault();
        if (
            typeof window !== 'undefined' &&
            window.OneTrust &&
            window.OneTrust.ToggleInfoDisplay
        ) {
            window.OneTrust.ToggleInfoDisplay();
        }
    };
    return (


        <PageFooter
            elementProps={{ logo: { style: { display: "none" } } }}
            disclaimer={"© " + currentYear + ", Managed DentalGuard, Inc., 5005 Rockside Road, Suite 430, Independence, OH 44131, U.S.A."}
            footerText={[
                <Text disclaimer onDarkBackground>
                       We are committed to protecting your privacy. Read our <TextLink
                        inlineSize="body-sm"
                        id="https://www.guardianlife.com/privacy-policy"
                        onClick={gotoLink}>
                        privacy policies
                    </TextLink> for more information.<br /><br />
                    <TextLink
                        inlineSize="body-sm"
                        id="cstgs"
                        onClick={openOneTrust}>
                        Do not sell or share my personal information
                    </TextLink>
                </Text>
            ]}
            socialMedia={{
                facebook: { link: 'https://www.facebook.com/guardianlife/', show: false },
                instagram: { link: 'https://instagram.com/guardianlife', show: false },
                linkedIn: { link: 'https://www.linkedin.com/company/the-guardian-life-insurance-company-of-america_164085?trk=company_logo', show: false },
                twitter: { link: 'https://twitter.com/intent/follow?source=followbutton&variant=1.0&screen_name=guardianlife', show: false },
                youtube: { link: 'https://www.youtube.com/c/guardianlife', show: false }
            }}
        />

        //   <PageFooter>
        //     Shape={{
        //         image:{link:'./images/MDCLogo.drawio.svg',show:false}
        //     }}

        //         {/* link:'./images/MDCLogo.drawio.svg' */}


        //   </PageFooter>




    )
}

export default FooterMDG
